import { apiPut } from './api';
import type { User } from '@/types';

/** Record on the account that this release's pop-up has been seen, so it does not return on any device. */
export const markWhatsNewSeen = (version: string) =>
  apiPut<User>('/api/users/me/whats-new-seen', { version });
